import {
  evaluateTemplateValue,
  dataLocationToPath,
} from '@ea-lab/reactive-json';

/**
 * Generic SYNCHRONOUS "serialize to JSON" reaction : writes
 * `JSON.stringify(source)` into the `target` store path, in the action chain.
 *
 * Why a reaction (config-first escape hatch) : reactive-json can't stringify,
 * so a value edited as structured data (e.g. a widgets array) can't be POSTed
 * to a plain text field. A `JsonMirror` component can mirror it, but its write
 * runs in a post-render `useEffect` — too late when the save `submitData` fires
 * synchronously in the SAME click. A reaction runs in order, so placing it
 * before the `submitData` guarantees the target holds the fresh JSON.
 *
 * Fully generic — reusable anywhere a store array/object must round-trip through
 * a text field.
 *
 * YAML usage (before the save) :
 *   - { what: stringifyData, on: click, source: ~~.dash.current.widgets,
 *       target: ~~.dash.current.saveData.layout }
 *   - { what: submitData, on: click, url: ~~.dash.current.submissionUrl, ... }
 *
 * Registered in App.jsx under `customPlugins.reaction.stringifyData`.
 */
export const stringifyDataReaction = (props) => {
  const { args, globalDataContext, templateContext } = props;
  if (!args) return;

  const gdc = globalDataContext.getRootContext
    ? globalDataContext.getRootContext()
    : globalDataContext;

  const source = evaluateTemplateValue({
    valueToEvaluate: args.source,
    globalDataContext: gdc,
    templateContext,
  });

  const path = typeof args.target === 'string'
    ? dataLocationToPath({
      dataLocation: args.target,
      currentPath: templateContext?.templatePath,
      globalDataContext: gdc,
      templateContext,
    })
    : null;
  if (!path) return;

  gdc.updateData(source === undefined ? '' : JSON.stringify(source), path);
};
